import type { LoaderFunctionArgs } from "@remix-run/node"
import { json } from "@remix-run/node"
import Header from "~/components/header"
import Typography from "~/components/typography"
import { Public } from "~/utils/remix"
import showdown from "showdown"
import { useLoaderData } from "@remix-run/react"
import { MetaFunction } from "@remix-run/node"

export const meta: MetaFunction = () => {
  return [
    { title: "2257 Statement of Compliance" },
    { property: "og:title", content: "2257 Statement of Compliance" },
    { name: "description", content: "Real World Sex Compliance statement" },
  ]
}

export const loader = Public(async ({ request, context }: LoaderFunctionArgs) => {
  const converter = new showdown.Converter()

  return json({
    user: context.user,
    content: converter.makeHtml(
      `
All persons that appear in any visual portrayal of actual or simulated sexually explicit conduct appearing on, or otherwise contained in, this Website were over the age of eighteen (18) years at the time the visual image was produced. Records required for all depictions of actual sexually explicit conduct by Title 18 U.S.C. 2257 are on file with the appropriate Records Custodian. All other visual depictions displayed on this Website are exempt from the provision of 18 U.S.C. 2257, 2257A and/or 28 C.F.R. 75, because 1) they do not portray conduct as specifically listed in 18 U.S.C section 2256 (2)(A) (i) through (iv), 2) they do not portray conduct as specifically listed in 18 U.S.C. section 2257A, 3) they do not portray conduct listed in 18 U.S.C. section 2256(2)(A)(v) produced after July 27, 2006, or 4) are otherwise exempt because the visual depictions were created prior to July 3, 1995.

    

The records required pursuant to 18 U.S.C. section 2257 and 2257(A) and 28 C.F.R. 75 for all materials contained in the website are kept by the following Custodian of Records:

    

2257Sentry, LLC  
Administrator  
50 Division Street, Suite 501  
Somerville, NJ 08876
    `
        .replace(/####/g, "#")
        .replace(/#####/g, "##")
    ),
  })
})

export default function VideoSubmissionAgreement() {
  const data = useLoaderData<typeof loader>()

  return (
    <div className="max-w-5xl m-auto mt-16">
      <Header title="2257 Statement of Compliance" />
      <div className="mx-4 md:mx-16">
        <Typography className="max-w-none">
          <div
            dangerouslySetInnerHTML={{
              __html: data.content || "",
            }}></div>
        </Typography>
      </div>
    </div>
  )
}
